type MaybeEvent = Event & { detail?: { originalEvent?: Event } }

function isElement(value: unknown): value is Element {
 return typeof Element !== "undefined" && value instanceof Element
}

function elementFromTarget(target: EventTarget | null): Element | null {
 if (!target) return null
 if (isElement(target)) return target
 // Sometimes event targets can be Text nodes (or other non-Element nodes)
 const node = target as unknown as Node
 return (node as any)?.parentElement ?? null
}

function getEventTarget(event: MaybeEvent): EventTarget | null {
 return (event.detail?.originalEvent?.target ?? event.target) ?? null
}

function getEventPathTargets(event: MaybeEvent): EventTarget[] {
 const anyEvent = event as unknown as { composedPath?: () => EventTarget[] }
 if (typeof anyEvent.composedPath === "function") return anyEvent.composedPath()
 const target = getEventTarget(event)
 return target ? [target] : []
}

function isReactSelectPortalElement(el: Element): boolean {
 const htmlEl = el as HTMLElement
 // react-select v5:
 // - MenuList: role="listbox"// - Option: role="option"// - Element ids prefixed by: react-select-<n>-*
 // - Portal wrapper has className"menu-portal"(and BEM-ish variants)
 // Radix UI Select (portaled list inside Dialog must not dismiss the dialog):
 return Boolean(
 htmlEl.closest('[role="listbox"]') ||
 htmlEl.closest('[role="option"]') ||
 htmlEl.closest('[id^="react-select-"]') ||
 htmlEl.closest(".menu-portal") ||
 htmlEl.closest('[class*="menu-portal"]') ||
 htmlEl.closest("[data-radix-select-content]") ||
 htmlEl.closest("[data-radix-popper-content-wrapper]")
 )
}

export function isReactSelectOutsideEvent(event: Event): boolean {
 const e = event as MaybeEvent
 const targets = getEventPathTargets(e)
 for (const t of targets) {
 const el = elementFromTarget(t)
 if (el && isReactSelectPortalElement(el)) return true
 }
 return false
}

function isFlatpickrPortalElement(el: Element): boolean {
 return Boolean((el as HTMLElement).closest(".flatpickr-calendar"))
}

/** Flatpickr يثبّت التقويم على body — يجب ألا يعامل Dialog/Sheet النقر عليه كإغلاق من الخارج */
export function isFlatpickrOutsideEvent(event: Event): boolean {
 const e = event as MaybeEvent
 const targets = getEventPathTargets(e)
 for (const t of targets) {
 const el = elementFromTarget(t)
 if (el && isFlatpickrPortalElement(el)) return true
 }
 return false
}

